import React from 'react';

import { ClassNameMap, OutlinedInputClassKey, TextField, TextFieldProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type BaseTextFieldProps = Omit<TextFieldProps, 'variant'> & {
  inputClasses?: Partial<ClassNameMap<OutlinedInputClassKey>>;
  mixHelperTextAndError?: boolean;
  errorHelperText?: React.ReactNode;
};


export const useHelperTextClasses = makeStyles<Partial<BaseTextFieldProps['FormHelperTextProps']>>({ name: 'BaseTextFieldHelperText' })({
  root: {
    display: 'block',
    fontSize: '0.875rem',
    marginLeft: 0,
    marginRight: 0,
  },
});


function DangerousHTMLText({ children, component: Component = 'span' }: { children: React.ReactNode; component?: React.ElementType }) {
  if (typeof children === 'string') {
    return (
      <Component
        dangerouslySetInnerHTML={{
          __html: children === ' ' ? '' : children
        }}
      />
    );
  }

  return <>{children}{null}</>;
}

export const BaseTextField = React.forwardRef<HTMLDivElement, BaseTextFieldProps>(({ helperText, errorHelperText, inputClasses, mixHelperTextAndError: showHelperTextAndError, ...props }, ref) => {
  const helperTextMixedWithError = React.useMemo(() => {
    if (!helperText && !errorHelperText) {
      return null;
    }

    if (showHelperTextAndError) {
      return (
        <div>
          <DangerousHTMLText component="div">{helperText}</DangerousHTMLText>
          {errorHelperText && <DangerousHTMLText component="div">{errorHelperText}</DangerousHTMLText>}
        </div>
      );
    }

    return <DangerousHTMLText>{errorHelperText || helperText}</DangerousHTMLText>;
  }, [ errorHelperText, helperText, showHelperTextAndError ]);

  return (
    <TextField
      {...props}
      ref={ref}
      helperText={helperTextMixedWithError}
      variant="outlined"
      slotProps={{
        ...props.slotProps,
        inputLabel: {
          ...props.InputLabelProps as any,
          ...props.slotProps?.inputLabel,
          color: props.color || props.InputProps?.color,
          className: undefined,
          shrink: true,
        },
        input: {
          ...props.InputProps as any,
          // ...props.inputProps as any,
          ...props.slotProps?.input,
          classes: inputClasses,
          enableAccessibleFieldDOMStructure: false,
          label: ' ',
        }
      }}
    />
  );
});
